import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { RemindersAdMonkeypoxPage } from './reminders-ad-monkeypox.page';

const routes: Routes = [
  {
    path: '',
    component: RemindersAdMonkeypoxPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RemindersAdMonkeypoxPageRoutingModule {}
